import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import WorkOrderNotification from 'workOrderComponents/WorkOrderNotification';
import TextFormatter from 'utils/TextFormatter';
import OutageDisplay from 'workOrderComponents/OutageDisplay';
import RepeatDisplay from 'workOrderComponents/RepeatDisplay';
import OrderDetailLoading from 'workOrderComponents/OrderDetailLoading';
import OrderStatusBar from 'orderStatusComponents/OrderStatusBar';
import NotesPanel from 'workOrderComponents/NotesPanel';
import PhoneMenu from 'workOrderComponents/PhoneMenu';
import { Link } from 'react-router-dom';
import FontIcon from 'material-ui/FontIcon';
import Divider from 'material-ui/Divider';
import EmailUpdater from 'accountComponents/EmailUpdater';
import * as colors from 'material-ui/styles/colors';
import TagEditor from 'workOrderComponents/TagEditor';
import HomeVerify from 'workOrderComponents/HomeVerify';
import * as orderStatusUtils from 'utils/orderStatusUtils';
import { getEmailUpdateResponseMessages } from '../../utils/emailUpdateUtils';
import { Map } from 'immutable';
import { yellow700 } from 'material-ui/styles/colors';

const WorkOrderCard = (props) => {

  const { workOrder, workOrderActions, showSummary, showSummaryEnabled, techId, billingSystem, customerDetail, orderId } = props;

  if (!workOrder) {
    return null;
  }

  const schedulingSystemDetails = workOrder.getIn(['schedulingSystemDetails', 'details']);
  const networkDetails = workOrder.getIn(['networkDetails', 'details']);
  const callAhead = workOrder.getIn(['callAhead', 'details']);
  const serviceOrderInfo = schedulingSystemDetails.get('serviceOrderInfoV2');
  const addressInfo = schedulingSystemDetails.get('addressInfo');
  const customerInfo = schedulingSystemDetails.get('customerInfo');
  const accountCustomerInfo = workOrder.getIn(['customerDetails', 'details']);
  const appointmentInfo = schedulingSystemDetails.get('appointmentInfo');
  const orderDetails = workOrder.getIn(['orderDetails', 'details']);
  const orderStatus = workOrder.getIn(['orderStatus']);
  const repeatStatus = workOrder.getIn(['repeatStatus', 'details']);
  const emailSuccessData = customerDetail && customerDetail.getIn(['newEmail', 'successData']);
  const emailErrorData = customerDetail && customerDetail.getIn(['newEmail', 'errorData']);
  const customerDetailsFinishedLoading = workOrder.getIn(['customerDetails', 'loadingFinished']);
  const customerDetailsIsLoading = workOrder.getIn(['customerDetails', 'loading']);

  const {emailUpdateSuccessMessage, emailUpdateFailedMessage} = getEmailUpdateResponseMessages(
    emailSuccessData,
    emailErrorData,
    customerDetail && customerDetail.getIn(['newEmail', 'status']),
  );

  let buttonDisplay = null;

  let color = '',
    foreColor = '',
    labelColor = colors.grey500,
    rootContainerClass = '';

  if (orderStatusUtils.isFinalState(orderStatus)) {
    color = colors.grey400;
    foreColor = colors.white;
    labelColor = colors.lightWhite;
    rootContainerClass = 'wow-fst-complete-order-container';
  }

  if (props.showViewButton && workOrder.getIn(['orderDetails', 'loadingFinished'])) {

    const viewOrderLink = (<Link to={`/work-order-detail/${serviceOrderInfo.get('serviceOrderId')}`} />);
    const viewIcon = (
      <FontIcon className="material-icons">open_in_browser</FontIcon>
    );

    buttonDisplay = (<RaisedButton
      fullWidth
      primary
      labelPosition="before"
      icon={viewIcon}
      label={"View"}
      containerElement={viewOrderLink} />);
  }

  const addressDisplay = TextFormatter.parseAddress(addressInfo.get('street1'), addressInfo.get('city'), addressInfo.get('state'), addressInfo.get('zip'));

  let displayNode = 'N/A';
  if (networkDetails) {
    displayNode = networkDetails.get('node');
  }

  const nameDisplayPhoneMenu = (<PhoneMenu
    loading={workOrder.getIn(['customerDetails', 'loading'])}
    customerInfo={customerInfo}
    accountCustomerInfo={accountCustomerInfo} />);

  if (showSummary && showSummaryEnabled) {
    return (
      <div>
        <h6>
          {serviceOrderInfo.get('serviceOrderId')}</h6>
        <h6>{appointmentInfo.getIn(['timeWindow', 'startTime'])}
          - {appointmentInfo.getIn(['timeWindow', 'endTime'])}</h6>
        {serviceOrderInfo.get('serviceTypeId')}
      </div>
    );
  }
  let tagEditor = null;
  if (accountCustomerInfo && networkDetails && schedulingSystemDetails && customerInfo && serviceOrderInfo) {
    tagEditor = (
      <TagEditor
        onChange={workOrderActions.setTagNumbers}
        onSave={workOrderActions.tagUpdateStarted}
        setTagEditing={workOrderActions.setTagEditing}
        networkDetails={networkDetails}
        billingSystem={schedulingSystemDetails.get('billingSystem')}
        accountNumber={accountCustomerInfo.get('accountNumber')}
        orderId={serviceOrderInfo.get('serviceOrderId')}
        houseNumber={customerInfo.get('customerId')} />
    );
  }

  let businessNameDisplay = null;
  let businessName = null;
  if(accountCustomerInfo){
    const customerType = accountCustomerInfo.get('customerType');
    if (customerType && customerType.toUpperCase() === "COMMERCIAL") {
      businessName = accountCustomerInfo.get('customerBusinessName');
      if (businessName && businessName.length > 0) {
        businessNameDisplay = (
          <div className="col s12 m12 l12">
            {businessName}
          </div>
        );
      }
    }
  }

  const accountDetailsMissingWarning = (
    <div style={{'color': yellow700, 'padding':'3%', 'display':'flex', 'alignItems':'center'}}>
      Warning: This order isn't associated with a customer account. Customer-related features will be disabled.
    </div>
  );

  const showLoginEmail = customerDetail && customerDetail.get('loginEmailEditEnabled');

  const basicRequirementsForEmailsMet = customerDetail && orderId && billingSystem;

  const emailDisplay = (
    <div className="row">
      <div className="col s12">
        {basicRequirementsForEmailsMet ?
          (<EmailUpdater
            orderId={orderId}
            workOrderActions={workOrderActions}
            customerDetail={customerDetail}
            billingSystem={billingSystem}
            houseNumber={customerInfo.get('customerId')} />)
          : null}
      </div>
      <br  />
      &nbsp;
      <div className="col s12">
        {basicRequirementsForEmailsMet && showLoginEmail ?
          (<EmailUpdater
            orderId={orderId}
            workOrderActions={workOrderActions}
            customerDetail={customerDetail}
            billingSystem={billingSystem}
            houseNumber={customerInfo.get('customerId')}
            isLoginEmail={true}/>)
          : null}
      </div>
    </div>
  );

  const displayErrorMessage = (
    <div className="row">
      <div className="col s12">
        {emailSuccessData || emailErrorData ?
          (<div
            className="row"
          >
            <FontIcon
              className="material-icons"
              style={{
                color: '#000',
                fontSize: '18px',
                padding: '0.15rem 0'
              }}
              onTouchTap={() => workOrderActions.updateCustomerEmailMessageReset(orderId)}
            >
              close
            </FontIcon>
            {emailUpdateSuccessMessage ? (
              <div className="col s11" style={{ color: 'rgb(76, 175, 80)' }}>
                {emailUpdateSuccessMessage}
              </div>
            ) : null}
            {emailUpdateFailedMessage ? (
              <div className="col s11" style={{ color: 'rgb(244, 67, 54)' }}>
                {emailUpdateFailedMessage}
              </div>
            ) : null}
          </div>)
          : null}
      </div>
    </div>
  );
  return (
    <div
      className={rootContainerClass}
      style={{
        backgroundColor: color,
        color: foreColor
      }}>

      <div
        className="padx2 row"
        style={{
          paddingBottom: '10px'
        }}>
          {(!accountCustomerInfo && customerDetailsFinishedLoading) ? accountDetailsMissingWarning : null }
          {(accountCustomerInfo || customerDetailsIsLoading) ? (
            <div className="col s12 m12 l12">
              { nameDisplayPhoneMenu }
            </div>
          ) : null}
        {businessNameDisplay}
        <div
          className="col s6 m8 l6 text-align-left"
          style={{
            paddingRight: '1px'
          }}>
          <a href={TextFormatter.generateMapLink(addressDisplay.street1, addressDisplay.city, addressDisplay.stateZip)} target='_blank' rel="noopener noreferrer">
            {TextFormatter.titleCase('', addressDisplay.street1)}
            <br /> {TextFormatter.titleCase(' ', addressDisplay.street2, addressDisplay.city)}, {addressDisplay.stateZip}
          </a>
          <br />
          <label style={{
            labelColor
          }}>Node:&nbsp;</label>{displayNode}
          <br />
          <OrderDetailLoading
            message="loading..."
            isLoading={workOrder.getIn(['networkDetails', 'loading'])} />
        </div>

        <div
          className="col s6 m4 l6 text-align-center"
          style={{
            paddingLeft: '1px'
          }}>
          <div>
            {serviceOrderInfo.get('serviceOrderId')}</div>
          <div>
            {appointmentInfo.getIn(['timeWindow', 'startTime'])} - {appointmentInfo.getIn(['timeWindow', 'endTime'])}
          </div>
          {serviceOrderInfo.get('serviceTypeDescription')}
        </div>
      </div>

      <div style={{ margin: '10px' }}>
        {emailDisplay}
      </div>
      <div style={{ margin: '10px' }}>
        {displayErrorMessage}
      </div>
      <WorkOrderNotification
        icon="access_time"
        isLoading={workOrder.getIn(['callAhead', 'loading'])}
        loadingMessage="Checking for call ahead..."
        hasData={!!callAhead}
        style={{ paddingTop: '5px' }}
        message={callAhead}
        iconColor=""
        className="" />

      <RepeatDisplay
        repeatStatus={repeatStatus}
        isLoading={workOrder.getIn(['repeatStatus', 'isLoading'])} />

      <OutageDisplay
        nodeOutage={workOrder.getIn(['nodeOutage'])}
        onRefresh={() => workOrderActions.clearWorkOrderDetail(serviceOrderInfo.get('serviceOrderId'), 'nodeOutage')}
        isLoading={workOrder.getIn(['nodeOutage', 'loading'])}
        loadingMessage="Checking for outages..." />

      <Divider />

      <NotesPanel
        orderDetails={orderDetails}
        workOrderActions={workOrderActions}
        networkDetails={networkDetails}
        orderId={serviceOrderInfo.get('serviceOrderId')}
        houseNumber={customerInfo.get('customerId')} />

      {tagEditor}

      <OrderStatusBar
        orderStatus={orderStatus}
        duration={serviceOrderInfo.get('durationInMinutes')}
      />

      <Divider />

      <HomeVerify
        homeVerify={workOrder.getIn(['homeVerify'])}
        workOrderActions={workOrderActions}
        orderId={serviceOrderInfo.get('serviceOrderId')}
        hideHomeVerify={props.showViewButton}
        techId={techId}
      />

      {buttonDisplay}

    </div>

  );
};

WorkOrderCard.propTypes = {
  workOrder: PropTypes.object,
  workOrderActions: PropTypes.object,
  showViewButton: PropTypes.bool,
  showSummary: PropTypes.bool,
  showSummaryEnabled: PropTypes.bool,
  techId: PropTypes.string,
  billingSystem: PropTypes.string,
  customerDetail: PropTypes.object,
  orderId: PropTypes.string,
};

export default WorkOrderCard;



// WEBPACK FOOTER //
// ./src/components/work-order/WorkOrderCard.js